// state
const state = {
  kpisCRM: null,
  solicitationsGis: null,
  citizenGlobalGis: null,
  consultationsGis: null,
  damageGis: null,
  complaintsGis: null,
  numComplaintsGis: null,
  layers: {
    solicitations: ['solicitations', 'UPDATE_SOLICITATIONS_GIS'],
    citizenGlobal: ['citizenGlobal', 'UPDATE_CITIZENS_GLOBAL_GIS']
  }
}

// getters
const getters = {
  getNumComplaintsGisData (state) {
    return state.numComplaintsGis
  },
  getComplaintsGisData (state) {
    return state.complaintsGis
  },
  getDamageGisData (state) {
    return state.damageGis
  },
  getConsultationsGisData (state) {
    return state.consultationsGis
  },
  getSolicitationsGisData (state) {
    return state.solicitationsGis
  },
  getCitizenGlobalGisData (state) {
    return state.citizenGlobalGis
  },
  getkpisCRM (state) {
    return state.kpisCRM
  }
}

// actions
const actions = {
  // Update Data Gis
  getCRMGisData ({ commit, state }, data) {
    const store = this
    if (data !== undefined) {
      let dataService = {
        method: 'GET',
        endpoint: '/api/dashboard/environmentGis',
        data: null,
        params: {
          type: data[0],
          country: 'ES',
          region: 'ES-GC',
          city: 'ES LPA'
        },
        mutation: data[1]
      }
      store.dispatch('callService', dataService)
    }
  },
  // LLama a todos los Gis a la vez....
  getAllStationsCRM ({ commit, state }) {
    const store = this
    // gisData
    store.dispatch('getCRMGisData', state.layers.solicitations)
    store.dispatch('getCRMGisData', state.layers.citizenGlobal)
  },
  // Update data Kpis CRM
  updateKpisCRM ({ commit, state }, data) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/' + data.typeProduct,
      data: null,
      params: {
        // product: data.product,
        // typeProduct: data.typeProduct,
        type: data.type,
        city: 'ES LPA',
        from: data.timeStart,
        to: data.timeEnd,
        interval: data.interval,
        intervalUnit: data.intervalUnit
      },
      mutation: 'UPDATE_KPIS_CRM'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_COMPLAINTS_NUM_GIS (state, data) {
    state.numComplaintsGis = data
  },
  UPDATE_COMPLAINTS_GIS (state, data) {
    state.complaintsGis = data
  },
  UPDATE_DAMAGE_GIS (state, data) {
    state.damageGis = data
  },
  UPDATE_CONSULTATIONS_GIS (state, data) {
    state.consultationsGis = data
  },
  UPDATE_SOLICITATIONS_GIS (state, data) {
    state.solicitationsGis = data
  },
  UPDATE_CITIZENS_GLOBAL_GIS (state, data) {
    state.citizenGlobalGis = data
  },
  UPDATE_KPIS_CRM (state, data) {
    state.kpisCRM = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardCRM.js